import type * as Types from '../../graphql/types.d'

import type { DocumentNode } from 'graphql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type InsertListBlockMutationVariables = Types.Exact<{
	tripID: Types.Scalars['ID']['input']
	input: Types.BlockInput
}>

export type InsertListBlockMutation = {
	__typename?: 'Mutation'
	insertListBlock: {
		__typename?: 'blockInsertionReturnObj'
		insertedBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
		trip: {
			__typename: 'Trip'
			id: string
			title?: string | null
			description?: string | null
			departAt?: string | null
			returnAt?: string | null
			isOwner: boolean
			isPurchased: boolean
			isIndestructible: boolean
			numBlocks: number
			numHighlights: number
			numDestinations: number
			numSources: number
			unpublishedListing?: {
				__typename: 'Listing'
				hasUnpublishedChanges: boolean
				id: string
				isPublished: boolean
				rank: number
				title?: string | null
				description?: string | null
				basePrice?: number | null
				currency: string
				viewsCount: number
				thankYouMessage?: string | null
				suggestedPrice?: number | null
				avgRating: number
				numReviews: number
				owner: {
					__typename: 'User'
					id: string
					bio?: string | null
					instagramUsername?: string | null
					tiktokUsername?: string | null
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
				reviews?: Array<{
					__typename: 'Review'
					id: string
					starRating: number
					feedbackToCreator?: string | null
					comment?: string | null
					createdAt: string
					reviewer: {
						__typename: 'User'
						id: string
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
				}> | null
			} | null
			rootBlocks: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				position: number
				description?: string | null
			} | null>
			purchasedFrom?: {
				__typename: 'Trip'
				id: string
				owner?: {
					__typename: 'User'
					id: string
					email: string
					emailVerified: boolean
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
					hasSellerId: boolean
				} | null
			} | null
			owner?: {
				__typename: 'User'
				id: string
				email: string
				emailVerified: boolean
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
				hasSellerId: boolean
			} | null
		}
		parentBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
	}
}

export type InsertPlaceBlockMutationVariables = Types.Exact<{
	tripID: Types.Scalars['ID']['input']
	input: Types.BlockInput
}>

export type InsertPlaceBlockMutation = {
	__typename?: 'Mutation'
	insertPlaceBlock: {
		__typename?: 'blockInsertionReturnObj'
		insertedBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
		trip: {
			__typename: 'Trip'
			id: string
			title?: string | null
			description?: string | null
			departAt?: string | null
			returnAt?: string | null
			isOwner: boolean
			isPurchased: boolean
			isIndestructible: boolean
			numBlocks: number
			numHighlights: number
			numDestinations: number
			numSources: number
			unpublishedListing?: {
				__typename: 'Listing'
				hasUnpublishedChanges: boolean
				id: string
				isPublished: boolean
				rank: number
				title?: string | null
				description?: string | null
				basePrice?: number | null
				currency: string
				viewsCount: number
				thankYouMessage?: string | null
				suggestedPrice?: number | null
				avgRating: number
				numReviews: number
				owner: {
					__typename: 'User'
					id: string
					bio?: string | null
					instagramUsername?: string | null
					tiktokUsername?: string | null
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
				reviews?: Array<{
					__typename: 'Review'
					id: string
					starRating: number
					feedbackToCreator?: string | null
					comment?: string | null
					createdAt: string
					reviewer: {
						__typename: 'User'
						id: string
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
				}> | null
			} | null
			rootBlocks: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				position: number
				description?: string | null
			} | null>
			purchasedFrom?: {
				__typename: 'Trip'
				id: string
				owner?: {
					__typename: 'User'
					id: string
					email: string
					emailVerified: boolean
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
					hasSellerId: boolean
				} | null
			} | null
			owner?: {
				__typename: 'User'
				id: string
				email: string
				emailVerified: boolean
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
				hasSellerId: boolean
			} | null
		}
		parentBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
	}
}

export type InsertDestinationBlockMutationVariables = Types.Exact<{
	tripID: Types.Scalars['ID']['input']
	input: Types.BlockInput
}>

export type InsertDestinationBlockMutation = {
	__typename?: 'Mutation'
	insertDestinationBlock: {
		__typename?: 'blockInsertionReturnObj'
		insertedBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
		trip: {
			__typename: 'Trip'
			id: string
			title?: string | null
			description?: string | null
			departAt?: string | null
			returnAt?: string | null
			isOwner: boolean
			isPurchased: boolean
			isIndestructible: boolean
			numBlocks: number
			numHighlights: number
			numDestinations: number
			numSources: number
			unpublishedListing?: {
				__typename: 'Listing'
				hasUnpublishedChanges: boolean
				id: string
				isPublished: boolean
				rank: number
				title?: string | null
				description?: string | null
				basePrice?: number | null
				currency: string
				viewsCount: number
				thankYouMessage?: string | null
				suggestedPrice?: number | null
				avgRating: number
				numReviews: number
				owner: {
					__typename: 'User'
					id: string
					bio?: string | null
					instagramUsername?: string | null
					tiktokUsername?: string | null
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
				reviews?: Array<{
					__typename: 'Review'
					id: string
					starRating: number
					feedbackToCreator?: string | null
					comment?: string | null
					createdAt: string
					reviewer: {
						__typename: 'User'
						id: string
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
				}> | null
			} | null
			rootBlocks: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				position: number
				description?: string | null
			} | null>
			purchasedFrom?: {
				__typename: 'Trip'
				id: string
				owner?: {
					__typename: 'User'
					id: string
					email: string
					emailVerified: boolean
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
					hasSellerId: boolean
				} | null
			} | null
			owner?: {
				__typename: 'User'
				id: string
				email: string
				emailVerified: boolean
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
				hasSellerId: boolean
			} | null
		}
	}
}

export type InsertSourceBlockMutationVariables = Types.Exact<{
	tripID: Types.Scalars['ID']['input']
	input: Types.BlockInput
}>

export type InsertSourceBlockMutation = {
	__typename?: 'Mutation'
	insertSourceBlock: {
		__typename?: 'blockInsertionReturnObj'
		insertedBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
		trip: {
			__typename: 'Trip'
			id: string
			title?: string | null
			description?: string | null
			departAt?: string | null
			returnAt?: string | null
			isOwner: boolean
			isPurchased: boolean
			isIndestructible: boolean
			numBlocks: number
			numHighlights: number
			numDestinations: number
			numSources: number
			unpublishedListing?: {
				__typename: 'Listing'
				hasUnpublishedChanges: boolean
				id: string
				isPublished: boolean
				rank: number
				title?: string | null
				description?: string | null
				basePrice?: number | null
				currency: string
				viewsCount: number
				thankYouMessage?: string | null
				suggestedPrice?: number | null
				avgRating: number
				numReviews: number
				owner: {
					__typename: 'User'
					id: string
					bio?: string | null
					instagramUsername?: string | null
					tiktokUsername?: string | null
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
				reviews?: Array<{
					__typename: 'Review'
					id: string
					starRating: number
					feedbackToCreator?: string | null
					comment?: string | null
					createdAt: string
					reviewer: {
						__typename: 'User'
						id: string
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
				}> | null
			} | null
			rootBlocks: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				position: number
				description?: string | null
			} | null>
			purchasedFrom?: {
				__typename: 'Trip'
				id: string
				owner?: {
					__typename: 'User'
					id: string
					email: string
					emailVerified: boolean
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
					hasSellerId: boolean
				} | null
			} | null
			owner?: {
				__typename: 'User'
				id: string
				email: string
				emailVerified: boolean
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
				hasSellerId: boolean
			} | null
		}
		parentBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
	}
}

export type InsertHighlightBlockMutationVariables = Types.Exact<{
	tripID: Types.Scalars['ID']['input']
	input: Types.BlockInput
}>

export type InsertHighlightBlockMutation = {
	__typename?: 'Mutation'
	insertHighlightBlock: {
		__typename?: 'blockInsertionReturnObj'
		insertedBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
		trip: {
			__typename: 'Trip'
			id: string
			title?: string | null
			description?: string | null
			departAt?: string | null
			returnAt?: string | null
			isOwner: boolean
			isPurchased: boolean
			isIndestructible: boolean
			numBlocks: number
			numHighlights: number
			numDestinations: number
			numSources: number
			unpublishedListing?: {
				__typename: 'Listing'
				hasUnpublishedChanges: boolean
				id: string
				isPublished: boolean
				rank: number
				title?: string | null
				description?: string | null
				basePrice?: number | null
				currency: string
				viewsCount: number
				thankYouMessage?: string | null
				suggestedPrice?: number | null
				avgRating: number
				numReviews: number
				owner: {
					__typename: 'User'
					id: string
					bio?: string | null
					instagramUsername?: string | null
					tiktokUsername?: string | null
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
				reviews?: Array<{
					__typename: 'Review'
					id: string
					starRating: number
					feedbackToCreator?: string | null
					comment?: string | null
					createdAt: string
					reviewer: {
						__typename: 'User'
						id: string
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
				}> | null
			} | null
			rootBlocks: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				position: number
				description?: string | null
			} | null>
			purchasedFrom?: {
				__typename: 'Trip'
				id: string
				owner?: {
					__typename: 'User'
					id: string
					email: string
					emailVerified: boolean
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
					hasSellerId: boolean
				} | null
			} | null
			owner?: {
				__typename: 'User'
				id: string
				email: string
				emailVerified: boolean
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
				hasSellerId: boolean
			} | null
		}
		parentBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
	}
}

export type InsertRegionBlockMutationVariables = Types.Exact<{
	tripID: Types.Scalars['ID']['input']
	input: Types.BlockInput
}>

export type InsertRegionBlockMutation = {
	__typename?: 'Mutation'
	insertRegionBlock: {
		__typename?: 'blockInsertionReturnObj'
		insertedBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
		trip: {
			__typename: 'Trip'
			id: string
			title?: string | null
			description?: string | null
			departAt?: string | null
			returnAt?: string | null
			isOwner: boolean
			isPurchased: boolean
			isIndestructible: boolean
			numBlocks: number
			numHighlights: number
			numDestinations: number
			numSources: number
			unpublishedListing?: {
				__typename: 'Listing'
				hasUnpublishedChanges: boolean
				id: string
				isPublished: boolean
				rank: number
				title?: string | null
				description?: string | null
				basePrice?: number | null
				currency: string
				viewsCount: number
				thankYouMessage?: string | null
				suggestedPrice?: number | null
				avgRating: number
				numReviews: number
				owner: {
					__typename: 'User'
					id: string
					bio?: string | null
					instagramUsername?: string | null
					tiktokUsername?: string | null
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
				reviews?: Array<{
					__typename: 'Review'
					id: string
					starRating: number
					feedbackToCreator?: string | null
					comment?: string | null
					createdAt: string
					reviewer: {
						__typename: 'User'
						id: string
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
				}> | null
			} | null
			rootBlocks: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				position: number
				description?: string | null
			} | null>
			purchasedFrom?: {
				__typename: 'Trip'
				id: string
				owner?: {
					__typename: 'User'
					id: string
					email: string
					emailVerified: boolean
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
					hasSellerId: boolean
				} | null
			} | null
			owner?: {
				__typename: 'User'
				id: string
				email: string
				emailVerified: boolean
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
				hasSellerId: boolean
			} | null
		}
		parentBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
	}
}

export type InsertCustomRegionBlockMutationVariables = Types.Exact<{
	tripID: Types.Scalars['ID']['input']
	input: Types.BlockInput
}>

export type InsertCustomRegionBlockMutation = {
	__typename?: 'Mutation'
	insertCustomRegionBlock: {
		__typename?: 'blockInsertionReturnObj'
		insertedBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
		trip: {
			__typename: 'Trip'
			id: string
			title?: string | null
			description?: string | null
			departAt?: string | null
			returnAt?: string | null
			isOwner: boolean
			isPurchased: boolean
			isIndestructible: boolean
			numBlocks: number
			numHighlights: number
			numDestinations: number
			numSources: number
			unpublishedListing?: {
				__typename: 'Listing'
				hasUnpublishedChanges: boolean
				id: string
				isPublished: boolean
				rank: number
				title?: string | null
				description?: string | null
				basePrice?: number | null
				currency: string
				viewsCount: number
				thankYouMessage?: string | null
				suggestedPrice?: number | null
				avgRating: number
				numReviews: number
				owner: {
					__typename: 'User'
					id: string
					bio?: string | null
					instagramUsername?: string | null
					tiktokUsername?: string | null
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
				reviews?: Array<{
					__typename: 'Review'
					id: string
					starRating: number
					feedbackToCreator?: string | null
					comment?: string | null
					createdAt: string
					reviewer: {
						__typename: 'User'
						id: string
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
				}> | null
			} | null
			rootBlocks: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				position: number
				description?: string | null
			} | null>
			purchasedFrom?: {
				__typename: 'Trip'
				id: string
				owner?: {
					__typename: 'User'
					id: string
					email: string
					emailVerified: boolean
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
					hasSellerId: boolean
				} | null
			} | null
			owner?: {
				__typename: 'User'
				id: string
				email: string
				emailVerified: boolean
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
				hasSellerId: boolean
			} | null
		}
		parentBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
	}
}

export type InsertPinBlockMutationVariables = Types.Exact<{
	tripID: Types.Scalars['ID']['input']
	input: Types.BlockInput
}>

export type InsertPinBlockMutation = {
	__typename?: 'Mutation'
	insertPinBlock: {
		__typename?: 'blockInsertionReturnObj'
		insertedBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
		trip: {
			__typename: 'Trip'
			id: string
			title?: string | null
			description?: string | null
			departAt?: string | null
			returnAt?: string | null
			isOwner: boolean
			isPurchased: boolean
			isIndestructible: boolean
			numBlocks: number
			numHighlights: number
			numDestinations: number
			numSources: number
			unpublishedListing?: {
				__typename: 'Listing'
				hasUnpublishedChanges: boolean
				id: string
				isPublished: boolean
				rank: number
				title?: string | null
				description?: string | null
				basePrice?: number | null
				currency: string
				viewsCount: number
				thankYouMessage?: string | null
				suggestedPrice?: number | null
				avgRating: number
				numReviews: number
				owner: {
					__typename: 'User'
					id: string
					bio?: string | null
					instagramUsername?: string | null
					tiktokUsername?: string | null
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
				reviews?: Array<{
					__typename: 'Review'
					id: string
					starRating: number
					feedbackToCreator?: string | null
					comment?: string | null
					createdAt: string
					reviewer: {
						__typename: 'User'
						id: string
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
				}> | null
			} | null
			rootBlocks: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				position: number
				description?: string | null
			} | null>
			purchasedFrom?: {
				__typename: 'Trip'
				id: string
				owner?: {
					__typename: 'User'
					id: string
					email: string
					emailVerified: boolean
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
					hasSellerId: boolean
				} | null
			} | null
			owner?: {
				__typename: 'User'
				id: string
				email: string
				emailVerified: boolean
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
				hasSellerId: boolean
			} | null
		}
		parentBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
	}
}

export type InsertDayBlockMutationVariables = Types.Exact<{
	tripID: Types.Scalars['ID']['input']
	destinationID: Types.Scalars['ID']['input']
	input: Types.BlockInput
}>

export type InsertDayBlockMutation = {
	__typename?: 'Mutation'
	insertDayBlock: {
		__typename?: 'blockInsertionReturnObj'
		insertedBlocks: Array<{
			__typename: 'Block'
			parentDayId?: string | null
			parentListId?: string | null
			id: string
			description?: string | null
			title?: string | null
			createdAt: string
			isOrigin: boolean
			isDestination: boolean
			isRootBlock: boolean
			blockType: Types.BlockType
			parentId?: string | null
			numInList?: number | null
			numHighlights?: number | null
			rootId?: string | null
			position: number
			icon: Types.CustomIcon
			color: Types.CustomColor
			queryPosition: number
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
			parentList?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null
			lists: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
			} | null>
			childBlocks: Array<{
				__typename: 'Block'
				id: string
				description?: string | null
				title?: string | null
				createdAt: string
				isOrigin: boolean
				isDestination: boolean
				isRootBlock: boolean
				blockType: Types.BlockType
				parentId?: string | null
				numInList?: number | null
				numHighlights?: number | null
				rootId?: string | null
				position: number
				icon: Types.CustomIcon
				color: Types.CustomColor
				queryPosition: number
				childBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				blockAncestors: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
				} | null>
				destination?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				place?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				customRegion?: {
					__typename: 'Region'
					id: string
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
				customPin?: {
					__typename: 'Location'
					id: string
					lat: number
					lng: number
					type?: Types.LocationType | null
					shortName?: string | null
					longName?: string | null
					address?: string | null
					countryCode?: string | null
					googlePlaceID?: string | null
					googlePrimaryType?: string | null
					media?: Array<{
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					}> | null
				} | null
				requirementBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					createdAt: string
					updatedAt: string
					blockType: Types.BlockType
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
				} | null
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
				sources: Array<{
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					imageUrl?: string | null
					parentId?: string | null
					color: Types.CustomColor
					icon: Types.CustomIcon
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
				} | null>
				routeAfter?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					parentDayId?: string | null
					parentListId?: string | null
					rootId?: string | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					route?: {
						__typename: 'Route'
						id: string
						units: string
						distance: number
						time: number
						toll: boolean
						ferry: boolean
						isFound: boolean
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
				} | null
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
			} | null>
			point?: { __typename: 'CommonPoint'; id: string; lat: number; lng: number } | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			blockAncestors: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
			} | null>
			destination?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			place?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			customRegion?: {
				__typename: 'Region'
				id: string
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
			customPin?: {
				__typename: 'Location'
				id: string
				lat: number
				lng: number
				type?: Types.LocationType | null
				shortName?: string | null
				longName?: string | null
				address?: string | null
				countryCode?: string | null
				googlePlaceID?: string | null
				googlePrimaryType?: string | null
				media?: Array<{
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				}> | null
			} | null
			requirementBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				createdAt: string
				updatedAt: string
				blockType: Types.BlockType
				procedures?: Array<{
					__typename?: 'Procedure'
					id: string
					sherpaID: string
					title: string
					description: string
					more: Array<string>
					category: Types.ProcedureCategory
					stage: Types.ProcedureStage
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					durationInDays?: Array<string> | null
					minimumDurationInDays?: string | null
					travelPurpose?: Array<string> | null
					alternativeMeasures?: Array<string> | null
					medicalRequirements?: Array<string> | null
					documentType?: Array<string> | null
					vaccination: Types.VaccinationStatus
					enforcement?: Types.ProcedureEnforcement | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
				restrictions?: Array<{
					__typename: 'Restriction'
					id: string
					sherpaID: string
					title: string
					description: string
					settingsDescriptor?: string | null
					more?: Array<string> | null
					category: Types.RestrictionCategory
					subCategory: Types.RestrictionSubCategory
					lastCheckedAt?: string | null
					stillCurrentAt?: string | null
					severity: number
					directionality?: Types.RestrictionDirectionality | null
					travelPurpose?: Array<string> | null
					tags?: Array<string> | null
					sources?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					providers?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
					documents?: Array<{
						__typename?: 'ExternalSource'
						id: string
						type?: Types.SourceType | null
						title: string
						description?: string | null
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						imageAlt?: string | null
						siteName?: string | null
						locale?: string | null
						localeAlternatives?: Array<string> | null
						sherpaID?: string | null
						provider?: string | null
						intent?: string | null
						productID?: string | null
					}> | null
				}> | null
			} | null
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
			sources: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				imageUrl?: string | null
				parentId?: string | null
				color: Types.CustomColor
				icon: Types.CustomIcon
				source?: {
					__typename: 'ExternalSource'
					id: string
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					siteName?: string | null
					title: string
					description?: string | null
				} | null
			} | null>
			routeAfter?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDayId?: string | null
				parentListId?: string | null
				rootId?: string | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				route?: {
					__typename: 'Route'
					id: string
					units: string
					distance: number
					time: number
					toll: boolean
					ferry: boolean
					isFound: boolean
					markers?: Array<{
						__typename: 'Marker'
						id: string
						lat: number
						lng: number
					} | null> | null
				} | null
			} | null
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
		}>
		trip: {
			__typename: 'Trip'
			id: string
			title?: string | null
			description?: string | null
			departAt?: string | null
			returnAt?: string | null
			isOwner: boolean
			isPurchased: boolean
			isIndestructible: boolean
			numBlocks: number
			numHighlights: number
			numDestinations: number
			numSources: number
			unpublishedListing?: {
				__typename: 'Listing'
				hasUnpublishedChanges: boolean
				id: string
				isPublished: boolean
				rank: number
				title?: string | null
				description?: string | null
				basePrice?: number | null
				currency: string
				viewsCount: number
				thankYouMessage?: string | null
				suggestedPrice?: number | null
				avgRating: number
				numReviews: number
				owner: {
					__typename: 'User'
					id: string
					bio?: string | null
					instagramUsername?: string | null
					tiktokUsername?: string | null
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
				reviews?: Array<{
					__typename: 'Review'
					id: string
					starRating: number
					feedbackToCreator?: string | null
					comment?: string | null
					createdAt: string
					reviewer: {
						__typename: 'User'
						id: string
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
				}> | null
			} | null
			rootBlocks: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				position: number
				description?: string | null
			} | null>
			purchasedFrom?: {
				__typename: 'Trip'
				id: string
				owner?: {
					__typename: 'User'
					id: string
					email: string
					emailVerified: boolean
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
					hasSellerId: boolean
				} | null
			} | null
			owner?: {
				__typename: 'User'
				id: string
				email: string
				emailVerified: boolean
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
				hasSellerId: boolean
			} | null
		}
	}
}

export const InsertListBlockDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'InsertListBlock' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockInput' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'insertListBlock' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'tripID' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'insertedBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'trip' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripBaseFields' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'parentBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExtendedBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentList' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'lists' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'childBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'childBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'point' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOrigin' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isDestination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isRootBlock' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numInList' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'queryPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'blockAncestors' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'destination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'place' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customRegion' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomRegionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customPin' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requirementBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'RequirementsBlockFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'routeAfter' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'LocationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Location' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePlaceID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePrimaryType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'media' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CustomRegionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RequirementsBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ProcedureFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Procedure' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'durationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'minimumDurationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'alternativeMeasures' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'medicalRequirements' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'vaccination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'enforcement' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExternalSourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageAlt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'locale' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'localeAlternatives' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'provider' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'intent' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'productID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RestrictionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Restriction' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'settingsDescriptor' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'subCategory' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'severity' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'directionality' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Route' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'units' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'distance' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'time' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'toll' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'ferry' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isFound' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripBaseFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rootBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'purchasedFrom' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'owner' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'UserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasSellerId' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const InsertPlaceBlockDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'InsertPlaceBlock' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockInput' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'insertPlaceBlock' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'tripID' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'insertedBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'trip' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripBaseFields' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'parentBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExtendedBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentList' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'lists' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'childBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'childBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'point' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOrigin' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isDestination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isRootBlock' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numInList' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'queryPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'blockAncestors' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'destination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'place' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customRegion' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomRegionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customPin' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requirementBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'RequirementsBlockFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'routeAfter' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'LocationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Location' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePlaceID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePrimaryType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'media' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CustomRegionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RequirementsBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ProcedureFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Procedure' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'durationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'minimumDurationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'alternativeMeasures' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'medicalRequirements' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'vaccination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'enforcement' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExternalSourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageAlt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'locale' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'localeAlternatives' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'provider' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'intent' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'productID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RestrictionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Restriction' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'settingsDescriptor' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'subCategory' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'severity' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'directionality' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Route' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'units' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'distance' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'time' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'toll' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'ferry' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isFound' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripBaseFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rootBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'purchasedFrom' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'owner' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'UserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasSellerId' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const InsertDestinationBlockDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'InsertDestinationBlock' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockInput' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'insertDestinationBlock' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'tripID' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'insertedBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'trip' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripBaseFields' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExtendedBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentList' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'lists' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'childBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'childBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'point' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOrigin' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isDestination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isRootBlock' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numInList' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'queryPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'blockAncestors' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'destination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'place' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customRegion' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomRegionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customPin' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requirementBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'RequirementsBlockFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'routeAfter' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'LocationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Location' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePlaceID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePrimaryType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'media' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CustomRegionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RequirementsBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ProcedureFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Procedure' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'durationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'minimumDurationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'alternativeMeasures' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'medicalRequirements' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'vaccination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'enforcement' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExternalSourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageAlt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'locale' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'localeAlternatives' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'provider' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'intent' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'productID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RestrictionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Restriction' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'settingsDescriptor' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'subCategory' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'severity' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'directionality' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Route' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'units' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'distance' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'time' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'toll' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'ferry' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isFound' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripBaseFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rootBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'purchasedFrom' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'owner' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'UserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasSellerId' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const InsertSourceBlockDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'InsertSourceBlock' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockInput' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'insertSourceBlock' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'tripID' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'insertedBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'trip' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripBaseFields' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'parentBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExtendedBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentList' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'lists' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'childBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'childBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'point' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOrigin' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isDestination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isRootBlock' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numInList' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'queryPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'blockAncestors' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'destination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'place' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customRegion' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomRegionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customPin' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requirementBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'RequirementsBlockFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'routeAfter' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'LocationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Location' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePlaceID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePrimaryType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'media' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CustomRegionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RequirementsBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ProcedureFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Procedure' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'durationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'minimumDurationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'alternativeMeasures' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'medicalRequirements' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'vaccination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'enforcement' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExternalSourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageAlt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'locale' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'localeAlternatives' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'provider' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'intent' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'productID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RestrictionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Restriction' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'settingsDescriptor' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'subCategory' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'severity' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'directionality' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Route' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'units' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'distance' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'time' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'toll' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'ferry' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isFound' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripBaseFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rootBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'purchasedFrom' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'owner' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'UserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasSellerId' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const InsertHighlightBlockDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'InsertHighlightBlock' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockInput' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'insertHighlightBlock' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'tripID' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'insertedBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'trip' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripBaseFields' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'parentBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExtendedBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentList' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'lists' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'childBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'childBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'point' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOrigin' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isDestination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isRootBlock' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numInList' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'queryPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'blockAncestors' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'destination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'place' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customRegion' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomRegionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customPin' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requirementBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'RequirementsBlockFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'routeAfter' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'LocationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Location' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePlaceID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePrimaryType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'media' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CustomRegionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RequirementsBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ProcedureFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Procedure' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'durationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'minimumDurationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'alternativeMeasures' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'medicalRequirements' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'vaccination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'enforcement' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExternalSourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageAlt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'locale' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'localeAlternatives' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'provider' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'intent' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'productID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RestrictionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Restriction' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'settingsDescriptor' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'subCategory' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'severity' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'directionality' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Route' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'units' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'distance' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'time' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'toll' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'ferry' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isFound' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripBaseFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rootBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'purchasedFrom' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'owner' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'UserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasSellerId' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const InsertRegionBlockDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'InsertRegionBlock' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockInput' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'insertRegionBlock' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'tripID' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'insertedBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'trip' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripBaseFields' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'parentBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExtendedBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentList' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'lists' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'childBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'childBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'point' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOrigin' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isDestination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isRootBlock' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numInList' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'queryPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'blockAncestors' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'destination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'place' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customRegion' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomRegionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customPin' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requirementBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'RequirementsBlockFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'routeAfter' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'LocationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Location' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePlaceID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePrimaryType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'media' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CustomRegionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RequirementsBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ProcedureFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Procedure' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'durationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'minimumDurationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'alternativeMeasures' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'medicalRequirements' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'vaccination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'enforcement' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExternalSourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageAlt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'locale' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'localeAlternatives' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'provider' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'intent' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'productID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RestrictionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Restriction' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'settingsDescriptor' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'subCategory' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'severity' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'directionality' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Route' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'units' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'distance' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'time' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'toll' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'ferry' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isFound' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripBaseFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rootBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'purchasedFrom' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'owner' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'UserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasSellerId' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const InsertCustomRegionBlockDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'InsertCustomRegionBlock' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockInput' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'insertCustomRegionBlock' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'tripID' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'insertedBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'trip' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripBaseFields' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'parentBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExtendedBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentList' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'lists' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'childBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'childBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'point' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOrigin' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isDestination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isRootBlock' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numInList' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'queryPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'blockAncestors' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'destination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'place' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customRegion' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomRegionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customPin' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requirementBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'RequirementsBlockFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'routeAfter' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'LocationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Location' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePlaceID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePrimaryType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'media' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CustomRegionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RequirementsBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ProcedureFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Procedure' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'durationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'minimumDurationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'alternativeMeasures' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'medicalRequirements' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'vaccination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'enforcement' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExternalSourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageAlt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'locale' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'localeAlternatives' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'provider' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'intent' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'productID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RestrictionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Restriction' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'settingsDescriptor' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'subCategory' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'severity' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'directionality' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Route' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'units' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'distance' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'time' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'toll' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'ferry' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isFound' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripBaseFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rootBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'purchasedFrom' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'owner' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'UserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasSellerId' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const InsertPinBlockDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'InsertPinBlock' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockInput' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'insertPinBlock' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'tripID' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'insertedBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'trip' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripBaseFields' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'parentBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExtendedBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentList' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'lists' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'childBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'childBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'point' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOrigin' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isDestination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isRootBlock' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numInList' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'queryPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'blockAncestors' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'destination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'place' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customRegion' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomRegionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customPin' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requirementBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'RequirementsBlockFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'routeAfter' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'LocationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Location' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePlaceID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePrimaryType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'media' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CustomRegionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RequirementsBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ProcedureFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Procedure' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'durationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'minimumDurationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'alternativeMeasures' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'medicalRequirements' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'vaccination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'enforcement' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExternalSourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageAlt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'locale' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'localeAlternatives' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'provider' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'intent' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'productID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RestrictionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Restriction' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'settingsDescriptor' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'subCategory' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'severity' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'directionality' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Route' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'units' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'distance' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'time' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'toll' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'ferry' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isFound' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripBaseFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rootBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'purchasedFrom' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'owner' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'UserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasSellerId' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const InsertDayBlockDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'InsertDayBlock' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'destinationID' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockInput' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'insertDayBlock' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'tripID' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripID' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'destinationID' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'destinationID' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'insertedBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ExtendedBlockFields' },
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'trip' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripBaseFields' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExtendedBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentList' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'lists' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListFields' } }],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'childBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'childBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'point' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOrigin' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isDestination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isRootBlock' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numInList' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'queryPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'blockAncestors' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'destination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'place' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customRegion' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomRegionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customPin' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requirementBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'RequirementsBlockFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'routeAfter' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'LocationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Location' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePlaceID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePrimaryType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'media' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CustomRegionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RequirementsBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ProcedureFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Procedure' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'durationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'minimumDurationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'alternativeMeasures' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'medicalRequirements' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'vaccination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'enforcement' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExternalSourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageAlt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'locale' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'localeAlternatives' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'provider' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'intent' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'productID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RestrictionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Restriction' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'settingsDescriptor' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'subCategory' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'severity' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'directionality' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Route' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'units' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'distance' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'time' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'toll' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'ferry' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isFound' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripBaseFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rootBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'purchasedFrom' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'owner' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'UserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasSellerId' } },
				],
			},
		},
	],
} as unknown as DocumentNode
